import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { CareersService } from '../../careers/services/careers.service';
import { Career } from '../../careers/models/career';
import { TrainingService } from '../../training/services/training.service';
import { TrainingProvider } from '../../training/models/trainingprovider'

@Component({
  selector: 'bookmark-section',
  templateUrl: './bookmark.component.html',
  providers: [CareersService, TrainingService]
})
export class BookmarkComponent implements OnInit {


  @Input()
  bookmarkType: string = "careers";

  @Input()
  section: string = "";

  @Input()
  alpha: string = "";

  @Input()
  activity: number = 0;

  @Input()
  group: number = 0;

  @Output()
  hasEnoughBookmarks: EventEmitter<boolean> = new EventEmitter<boolean>();

  subscription: Subscription;
  careers: Array<Career>;
  numOfBookmarks: number = 0;
  trainingBookmarks: Array<TrainingProvider>;
  timeout: boolean = false;

  constructor(private careerService: CareersService, private trainingService: TrainingService) { }

  ngOnInit() {
    this.checkForBookmarks();
  }

  ngAfterViewInit() {

    //emit value in sequence every 15 second
    const source = interval(15000);
    this.subscription = source.subscribe(val => this.checkForBookmarks());

    this.resetTimeout();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  checkForBookmarks() {
    console.log("bookmarkType: ", this.bookmarkType);
    if (this.bookmarkType == 'careers') {
      if (!this.timeout) {
        this.careerService.get().subscribe(res => {
          console.log('numbers of careers/bookmarks 1A:', res.length);
          this.careers = res;
          this.numOfBookmarks = res.length;

          if (this.numOfBookmarks > 2) {
            this.hasEnoughBookmarks.emit(true);
          }
        }, error => {
          console.log('bookmarks Error 1A:', error);
        });
      }
    }

    if (this.bookmarkType == 'training') {
      if (!this.timeout) {
        this.trainingService.getTrainingOrWioaProviders().subscribe(res => {
          console.log('numbers of training/bookmarks 1B:', res.length);
          this.trainingBookmarks = res;
          this.numOfBookmarks = res.length;

          if (this.numOfBookmarks > 2) {
            this.hasEnoughBookmarks.emit(true);
          }
        }, error => {
          console.log('bookmarks Error 1B:', error);
        });
      }
    }
  }

  resetTimeout() {
    this.timeout = false;

    setTimeout(() => {
      this.timeout = true;
    }, 300000);
  }
}
